import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right-slim",
  "use": "arrow-right-slim-usage",
  "viewBox": "0 0 25 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 8\" id=\"arrow-right-slim\"><path d=\"M24.354 4.354a.5.5 0 000-.708L21.172.464a.5.5 0 10-.707.708L23.293 4l-2.828 2.828a.5.5 0 10.707.708l3.182-3.182zM0 4.5h24v-1H0v1z\" fill=\"#357DF9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol